<template>
    <div class="flex-1 bg-ma-gray-0 mx-4 mb-6">
        <div class="thankyou-features-title bg-ma-blue-1 text-white uppercase p-3">
            <h2>{{ featureColumn.title }}</h2>
        </div>
        <div class="p-6 lg:px-8">
            <ThankyouFeature v-for="(feature, i) in featureColumn.features" :feature="feature" :key="i" />
        </div>
    </div>
</template>

<script>
import ThankyouFeature from './ThankyouFeature'

export default {
    components: {
        ThankyouFeature
    },
    props: {
        featureColumn: {
            required: true,
            type: Object
        }
    }
}
</script>